import { render, staticRenderFns } from "./PublicPaymentAuthentication.vue?vue&type=template&id=3b40e0aa"
import script from "./PublicPaymentAuthentication.vue?vue&type=script&lang=js"
export * from "./PublicPaymentAuthentication.vue?vue&type=script&lang=js"
import style0 from "./PublicPaymentAuthentication.vue?vue&type=style&index=0&id=3b40e0aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports